// Overriding the fetch function to ensure compatibility with the module's context.
// When working with a federated module, the global `fetch` instance (window.fetch) may differ from the host application's instance.
// This can cause issues with interceptors

export function proxyFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    if (init === undefined) {
        return fetch(input);
    }
    return fetch(input, init);
}
